import { render, staticRenderFns } from "./TolovForm.vue?vue&type=template&id=0c70ea45"
import script from "./TolovForm.vue?vue&type=script&lang=js"
export * from "./TolovForm.vue?vue&type=script&lang=js"
import style0 from "./TolovForm.vue?vue&type=style&index=0&id=0c70ea45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports